// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1188c80e","977":"8f08db8e"}[chunkId] + ".chunk.js";
};